/* eslint-disable no-empty-pattern */
import router from '../../router/index';
import axios from 'axios';
import { encrypt, decrypt } from '../../_services/encryption';
import { headers } from '@/_services/headers';
const state = {
    accessToken: localStorage.getItem('accessToken') || null,
    user: null,
    securityQuestion: null,
    gender: null,
    states: null,
    lga: null,
    idTypes: null,
    userSecurityQuestion: null,
    existingUser: [],
    userAccount: [],
    accountofficer: [],
    image: '',
    lastLogin: null,
};
const mutations = {
    SET_AUTH(state, userData) {
        state.accessToken = userData.accessToken;
        state.user = userData;
    },
    UPDATE_ACCESS_TOKEN: (state, accessToken) => {
        state.accessToken = accessToken;
    },
    //clear the token and user
    CLEAR_AUTH(state) {
        state.accessToken = null;
        state.user = null;  
    },
    // set image
    SET_IMAGE(state, image) {
        state.image = image;
    },
    // set security question
    SET_SECURITY_QUESTION(state, securityQuestion) {
        state.securityQuestion = securityQuestion;
    },
    // set gender mutation
    SET_GENDER(state, gender) {
        state.gender = gender;
    },
    // set state mutation
    SET_STATES(state, states) {
        state.states = states;
    },
    // set state for local government
    SET_LGA(state, lga) {
        state.lga = lga;
    },
    // set id type mutation
    SET_ID_TYPES(state, idTypes) {
        state.idTypes = idTypes;
    },
    // set user security question
    SET_USER_SECURITY_QUESTION(state, userSecurityQuestion) {
        state.userSecurityQuestion = userSecurityQuestion;
    },
    // set existing user
    SET_EXISTING_USER(state, existingUser) {
        state.existingUser = existingUser;
    },
    // set user account
    SET_USER_ACCOUNT(state, userAccount) {
        state.userAccount = userAccount;
    },
    // set account officer
    SET_ACCOUNT_OFFICER(state, accountofficer) {
        state.accountofficer = accountofficer;
    },
    // set last login
    SET_LAST_LOGIN(state, lastLogin) {
        state.lastLogin = lastLogin;
    }
};
const actions = {
    // login action
    async login({ commit }, userData) {
        const encryptedData = encrypt(userData);
        const resp = await axios.get('https://api.ipify.org?format=json');
        const ip = resp.data.ip;
        headers.REMOTE_ADDR = ip;
        let response = await axios.post('Authentication/login', encryptedData, { headers: headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_AUTH', userParseData.userDetails);
        //store accessToken in local storage
        localStorage.setItem('accessToken', userParseData.accessToken);
        localStorage.setItem('refreshToken', userParseData.refreshToken);
        localStorage.setItem('pinRequired', JSON.stringify(userParseData.userDetails.isPinRequired));
        localStorage.setItem('forceChangeOfPassword', userParseData.userDetails.forceChangeOfPassword);
        localStorage.setItem('isSecurityQuestion', userParseData.userDetails.isSecurityQuestionRequired);
        localStorage.setItem('email', userParseData.userDetails.email);
        localStorage.setItem('forceChangePin', userParseData.userDetails.forceChangeOfPIN);
        if(userParseData.userDetails.isSecurityQuestionRequired === true ) {
            router.push('/settings/reset-security-question').catch(()=>{});
        } else if(userParseData.userDetails.isPinRequired === true) {
            router.push('/settings/create-pin').catch(()=>{});
        } else if (userParseData.userDetails.forceChangeOfPassword === true) {
            router.push('/settings/change-password').catch(()=>{});
        } else if (userParseData.userDetails.email === '') {
            router.push('/services/account-update').catch(()=>{});
        } else {
            router.push('/dashboard/default');
        }
    },
    // update access token
    async updateAccessToken({ commit }) {
        commit('UPDATE_ACCESS_TOKEN', localStorage.getItem('accessToken'));
    },
    // action to call refresh token every 15 minutes
    async refreshToken({ commit }) {
        const data = {
            refreshToken: localStorage.getItem('refreshToken'),
            accessToken: localStorage.getItem('accessToken'),
        };
        const encryptedData = encrypt(data);
        let response = await axios.post('Authentication/refreshToken', encryptedData, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_AUTH', userParseData);
        localStorage.setItem('accessToken', userParseData.accessToken);
        localStorage.setItem('refreshToken', userParseData.refreshToken);
    },
    // reset password action
    async resetPassword({}, userData) {
        const encryptedData = encrypt(userData);
        let response = await axios.post('Authentication/resetPassword', encryptedData, { headers });
        return response;
    },
    // set last login
    async setLastLogin({ commit }, data) {
        const encryptedData = encrypt(data);
        let response = await axios.post(`Authentication/getLastLoginDate`, encryptedData , { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_LAST_LOGIN', userParseData);
    },
        // logout action 
    async logout({ commit, rootState }) {
        commit('CLEAR_AUTH');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('pinRequired');
        localStorage.removeItem('forceChangeOfPassword');
        localStorage.removeItem('isSecurityQuestion');
        localStorage.removeItem('email');
        localStorage.removeItem('forceChangePin');
        sessionStorage.removeItem('transactionList');
        rootState.dashboard.profilePicture = null;
        rootState.dashboard.dashboardData = null;
        router.push('/auth/login');
    },
    // get security question action
    async getSecurityQuestion({ commit }) {
        let response = await axios.get('SecurityQuestion/getSecurityQuestions', { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_SECURITY_QUESTION', userParseData);
        return response;
    },
    // validate bvn action
    async validateBvn({}, userData) {
        const encryptedData = encrypt(userData);
        let response = await this._vm.$http.post(`/Customer/validateBvn`, encryptedData, { headers });
        return response;
    },
    // validate bvn details action
    async validateBvnDetails({}, userData) {
        const encryptedData = encrypt(userData);
        let response = await this._vm.$http.post(`/Customer/validateBVNDetails`, encryptedData, { headers });
        return response;
    },
    // validate otp action
    async validateBvnOtp({}, userData) {
        const encryptedData = encrypt(userData);
        let response = await this._vm.$http.post(`/Customer/validateSignUpToken`, encryptedData, { headers });
        return response;
    },
    // generate sign up token action
    async generateSignUpToken({}, userData) {
        const encryptedData = encrypt(userData);
        let response = await this._vm.$http.post(`/Customer/generateSignUpToken`, encryptedData, { headers });
        return response;
    },
    // sign up new user
    async signUpNewUser({}, userData) {
        const encryptedData = encrypt(userData);
        let response = await this._vm.$http.post(`/Customer/newUser/SignUp`, encryptedData, { headers });
        return response;
    },
    // get user gender
    async getGender({ commit }) {
        let response = await this._vm.$http.get(`/Enum/getGender`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_GENDER', userParseData);
        return response;
    },
    // get states
    async getStates({ commit }) {
        let response = await this._vm.$http.get(`/State/getAll`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_STATES', userParseData);
        return response;
    },
    // get lga
    async getLga({ commit }, stateId) {
        let response = await this._vm.$http.get(`/LGA/getAll?stateId=${stateId}`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_LGA', userParseData);
        return response;
    },
    // get id types
    async getIdTypes({ commit }) {
        let response = await this._vm.$http.get(`/Enum/getIdTypes`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        commit('SET_ID_TYPES', userParseData);
        return response;
    },
    // verify document type
    async verifyDocumentType({}, userData) {
        headers.post['Content-Type'] = 'multipart/form-data';
        let response = await this._vm.$http.post(`/Customer/verifyDocument`, userData, { headers });
        return response;
    },
    // get user security question
    async getUserSecurityQuestion({ commit }, data) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await axios.post(`SecurityQuestion/getUserSecurityQuestions`, encryptedData , { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            commit('SET_USER_SECURITY_QUESTION', userParseData);
        }
    },
    // get existing user
    async signUpExistingUser({}, data) {
        const encryptedData = encrypt(data);
        let response = await this._vm.$http.post(`/Customer/existingUser/SignUp`, encryptedData, { headers });
        return response;
    },
    // get user account
    async getUserAccount({ commit }, data) {
        let response = await this._vm.$http.get(`/Account/getAccount?accountNumber=${data}&sendOTP=true`, { headers });
        commit('SET_USER_ACCOUNT', response.data);
        return response;
    },
    // get account officer
    async getAccountOfficer({ commit }, data) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            let response = await this._vm.$http.get(`/Account/GetAccountOfficerInformation?accountNumber=${data}`, { headers });
            commit('SET_ACCOUNT_OFFICER', response.data); 
            return response;
        }
    },
    // verify face
    async verifyFace({}, data) {
        headers.Accept = 'multipart/form-data';
        let response = await this._vm.$http.post(`/Customer/verifyFace`, data, { headers });
        return response;
    }
};
const getters = {
    // check if user is logged in
    isLoggedIn: state => {
        return state.accessToken !== null;
    },
};
export default {
    // namespaced: true,
    state,
    getters,
    actions,
    mutations,
};